import { BASE_CATEGORIES_URL, BASE_CATEGORY_URL } from '@/constants/API'
import { getNumberWithoutPostPositiveZero, getCategoryNumbers } from '@/utils/util'

export const LOAD_CATEGORIES = 'LOAD_CATEGORIES'
export const LOAD_CATEGORIES_ASYNC = 'LOAD_CATEGORIES_ASYNC'
export const LOAD_CATEGORY = 'LOAD_CATEGORY'
export const LOAD_CATEGORY_ASYNC = 'LOAD_CATEGORY_ASYNC'
export const CLEAR_CATEGORY = 'CLEAR_CATEGORY'

const category = {
  state: {
    doc: [],
    docs: []
  },
  getters: {
    categoryCount: state => state.doc.length,
    getCategoriesByNumber: state => state.doc.reduce((obj, t) => {
      obj[t.number] = t
      return obj
    }, {}),
    getCategoryByNumber: state => number => {
      if (state.doc.length > 0) {
        console.log(`getCategoryByNumber, number: ${number}`)
        return state.doc.find(dc => dc.number === number)
      }
      return null
    },
    getPosterityCategories: (state, getters) => number => {
      const reg = new RegExp(`^${getNumberWithoutPostPositiveZero(number)}`)
      console.log(`getPosterityCategories, number: ${number}`)
      return state.doc.filter(doc => {
        const value1 = getCategoryNumbers(doc.number)
        console.log(`getPosterityCategories, value1: ${value1}`)
        doc.titleDatas = value1.map(t => {
          if (undefined === getters.getCategoriesByNumber[t]) {
            return ''
          }
          return getters.getCategoriesByNumber[t].name
        })
        return String(doc.number).match(reg) && (doc.posts.length)
      })
    },
    getChildrenCategoryies: state => number => {
      const reference = String(getNumberWithoutPostPositiveZero(number))
      const len = reference.length
      const regExp = new RegExp(`^${reference}(0[1-9]|[1-9][0-9])(0){${8 - len}}`)
      return state.doc.filter(doc => String(doc.number).match(regExp))
    },
    getCategoryRootDatas: state => state.doc.filter(doc => Number(String(doc.number).slice(2)) === 0),
    getRecommendedCategories: state => state.doc.filter(t => t.recommend).sort((a, b) => a.index - b.index),
    getAllCategories: state => number => {
      console.log(`getAllCategories ${state.docs} ${number}`)
      return state.docs
    }
  },
  actions: {
    /* 按照id获取一篇文章 */
    [LOAD_CATEGORY_ASYNC]({ commit }, payload) {
      return new Promise((resolve, reject) => {
        this._vm.$axios({
          commit,
          url: `${BASE_CATEGORY_URL}${payload.id}`,
          doHideAlert: true,
          success(result) {
            // 保存文章
            commit(LOAD_CATEGORY, result.doc)
            // 向前端通知操作成功
            resolve(result.doc)
          },
          fail(err) {
            // 向前端通知操作失败
            reject(err)
          }
        })
      })
    },
    /* 获取全部类别信息 */
    [LOAD_CATEGORIES_ASYNC]({ commit }) {
      return new Promise((resolve, reject) => {
        this._vm.$axios({
          commit,
          url: BASE_CATEGORIES_URL,
          doHideAlert: true,
          success(result) {
            // 保存类别
            commit(LOAD_CATEGORIES, result.docs)
            // 向前端通知操作成功
            resolve(result.docs)
          },
          fail(err) {
            // 向前端通知操作失败
            reject(err)
          }
        })
      })
    }
  },
  mutations: {
    /* 保存类别信息 */
    [LOAD_CATEGORIES](state, payload) {
      state.docs = payload
    },
    /* 保存类别信息 */
    [LOAD_CATEGORY](state, payload) {
      state.doc = payload
    },
    /* 清空当前文章信息 */
    [CLEAR_CATEGORY](state) {
      state.doc = []
    }
  }
}
export default category



// WEBPACK FOOTER //
// ./src/components/Category/module.js